import { Box, Flex, Heading, Spinner, Text } from "@radix-ui/themes";
import { FC } from "react";
import { usePrecisionGameLeaderboard } from "../hooks/usePrecisionGameLeaderboard";
import { ErrorFallback } from "@/components";
import { PrecisionGameUIProps } from "../models/precisionGame.types";
import PrecisionGameUIWinnersItem from "./precision.game.ui.winners.item";
import i18next from "i18next";

const PrecisionGameUIWinners: FC<PrecisionGameUIProps> = ({
  collection,
  orientation = "horizontal",
  headline = i18next.t("precisionGame.leaderboard.headline"),
}): JSX.Element => {
  const { winners, loading, error } = usePrecisionGameLeaderboard(collection);
  const isVertical = orientation === "vertical";

  if (loading) {
    return <Spinner />;
  }

  if (error) {
    return <ErrorFallback>{error.message}</ErrorFallback>;
  }

  if (winners && winners.length > 0) {
    const sortedWinners = winners.sort((a, b) => {
      return a.attempts - b.attempts;
    });

    const winnersList = isVertical ? sortedWinners.slice(0, 10) : sortedWinners;

    return (
      <Flex direction="column" gap="3">
        <Heading as="h2" size="5" mb="0">
          {headline}
        </Heading>
        <Flex direction="column" gap="1">
          <Box width="100%">
            <Flex justify="between" gap="1">
              <Text as="div" size="2" weight="bold">
                {i18next.t("precisionGame.leaderboard.username")}
              </Text>
              <Text as="div" size="2" weight="bold">
                {i18next.t("precisionGame.leaderboard.attempts")}
              </Text>
            </Flex>
          </Box>
          <Flex gap="2" direction="column">
            {winnersList.map((record, index) => {
              const key = `winner-${index}`;

              return (
                <PrecisionGameUIWinnersItem
                  key={key}
                  uid={record.uid}
                  userName={record.userName}
                  score={record.attempts.toString()}
                  rank={index + 1}
                  orientation={orientation}
                />
              );
            })}
          </Flex>
        </Flex>
      </Flex>
    );
  }

  return (
    <Flex direction="column" gap="3">
      <Heading as="h2" size="5">
        {headline}
      </Heading>
      <Text size="2" color="gray">
        {i18next.t("precisionGame.leaderboard.none")}
      </Text>
    </Flex>
  );
};

export default PrecisionGameUIWinners;
